import React from 'react';
import InternalHero from './InternalHero';
import InternalFeatures from './InternalFeatures';
import RealWorkflow from './RealWorkflow';
import FeatureComparison from './FeatureComparison';
import PageLayout from '../PageLayout/PageLayout';
import './ProductInsurance.css';

export default function ProductIntelligencePage() {
  return (
    <div className="product-intelligence-page">
      <PageLayout fullBleed>
        <InternalHero />
        <InternalFeatures />
        <RealWorkflow />
        <FeatureComparison />
      </PageLayout>
    </div>
  );
}
